import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import ContactRequestSkeliton from './component/ContactRequestSkeliton';
import ContactRequestList from './component/ContactRequestList';
import NoDataFound from '../../../../component/common/NoDataFound';
import Pagination from '../../../../component/common/pagination/Pagination';

import { timezoneOffset } from '../../../../component/common/Helper';
const ContactRequest = (props) => {

    const {searchData} = props;

    const loginUserType = localStorage.getItem('type');
    const api_base_url = process.env.REACT_APP_API_URL;

    // ----- define all state here ----- //
    const [showLoader, setShowLoader] = useState(true);
    const [page, setPage] = useState(1);
    const [contactRequestData, setContactRequestData] = useState([]);
    const [paginationData, setPaginationData] = useState({});

    const getDataLimit = 50;

    const getcontactReportData = async () => {
        setShowLoader(true)
        let apiToken = '';
        if(loginUserType === 'A'){
            apiToken = localStorage.getItem('token')
        }
        else if(loginUserType === 'D'){
            apiToken = localStorage.getItem('developertoken')
        }
        else if(loginUserType === 'SA') {
            apiToken = localStorage.getItem('systemAdminToken')
        }
        var api_headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "x-access-token" : apiToken
            }
        };
        let reqData = {
            page: page,
            limit: getDataLimit,
            search_date: searchData,
            timeZone: timezoneOffset()
        }
        await axios.post(`${api_base_url}api/get-contact-request-data`, reqData, api_headers)
        .then(async (res) => {
            if(res.data.status === 'success') {
                setContactRequestData(res.data.data.data)
                setPaginationData({
                    current_pages : res.data.data.current_pages,
                    total_data_count : res.data.data.total_count,
                    total_pages : res.data.data.total_pages,
                    limit : res.data.data.limit,
                    data_length : res.data.data.data.length
                })
            } else if(res.data.status === 'error') {
                console.error('error')
            }
            setShowLoader(false)
            props.isRefresh(true)
        })
        .catch((error) => {
            setShowLoader(false)
            console.error(error);
        })
    }

    useEffect(() => {
        getcontactReportData()
    },[page])

    useEffect(() => {
        if (!searchData.isSearch || searchData.tabType !== 'contact_request') return;
        getcontactReportData()
    },[searchData])

    const pagechangeHandler = (pageNumber, type) => {
        if( type === 'previous' ){
            setPage((c_page) => c_page - 1)
        }else if( type === 'page' ){
            setPage(pageNumber)
        }
        else if( type === 'next' ){
            setPage((c_page) => c_page + 1)
        }
    }

    const contactRequestDeleteHandler = async (deleteId) => {
        await Swal.fire({
            text: 'Are you sure to delete this record ?',
            icon: 'error',
            showCancelButton: true,
            showConfirmButton : true,
            cancelButtonText: 'Cancel',
            confirmButtonText: 'OK, Delete',
        }).then(async (result) => {
            if (result.isConfirmed) {
                let apiToken = '';
                if(loginUserType === 'A'){
                    apiToken = localStorage.getItem('token')
                }
                else if(loginUserType === 'D'){
                    apiToken = localStorage.getItem('developertoken')
                }
                else if(loginUserType === 'SA') {
                    apiToken = localStorage.getItem('systemAdminToken')
                }
                var api_headers = {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "x-access-token" : apiToken
                    }
                };
                let reqData = {
                    deleteId: deleteId,
                }
                await axios.post(`${api_base_url}api/delete-contact-request-data`, reqData, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        toast.success(res.data.message);
                        getcontactReportData()
                    } else if(res.data.status === 'error') {
                        console.error('error')
                    }
                    setShowLoader(false)
                })
                .catch((error) => {
                    setShowLoader(false)
                    console.error(error);
                })
            }   
        })
    }

    let contactRequestHtml = '';
    if(contactRequestData.length > 0){
        contactRequestHtml = contactRequestData.map((contactRequest, index) => 
            <ContactRequestList
                key={index}
                contactRequest={contactRequest}
                contactRequestDelete={contactRequestDeleteHandler}
            />
        )
    }
    const hasData = contactRequestData.length > 0;
    const noData = !showLoader && !hasData;

    return (
        <> 
            <div className='card border'>
                <div className='card-body py-4'>
                    <div id="sai_table_users_wrapper" className="dataTables dt-bootstrap4 no-footer">
                        <div className="table-responsive">
                            {showLoader && <ContactRequestSkeliton totalRow={10}/>}
                            {
                                hasData &&
                                <table className="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                                            <th className="w-300px sorting">
                                                Name
                                            </th>
                                            <th className="w-250px sorting">
                                                Phone
                                            </th>
                                            <th className="w-200px">
                                                Organization
                                            </th>
                                            <th className="w-200px">
                                                Designation
                                            </th>
                                            <th className="w-200px">
                                                Select an option
                                            </th>
                                            <th className="w-200px">
                                                Comments
                                            </th>
                                            <th className="w-200px">
                                                Created at 
                                            </th>
                                            <th className="">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold set-system-user-list">
                                        {contactRequestHtml}
                                    </tbody>
                                </table>
                            }
                            {
                                noData &&
                                <NoDataFound
                                    setHtml="Contact Request Not Found"
                                    className="w-30"
                                />
                            }
                        </div>  
                    </div>
                </div>
            </div>
            {hasData && 
                <Pagination
                    pagination_data={paginationData}
                    onClick={pagechangeHandler}
                />
            } 
        </>
    )
}

export default ContactRequest